module.exports = __webpack_public_path__ + "assets/6d8ed6c0894e37c716c8b1edcc7dd039.png";